module.exports = __webpack_public_path__ + "img/22-tjdx.5324293b.png";